import React from 'react';
import { coreAdminApiBalanceApi } from '../api';
import { StatItem } from './statItem';
import { Price } from './price';

export const DadataBalance: React.FC = () => {
  const { data, isLoading } = coreAdminApiBalanceApi.endpoints.getApiBalance.useQuery();
  return <StatItem isLoading={isLoading} label="dadata" title="Текущий баланс Dadata" value={<Price integer value={data?.dadata} />} />;
};
